var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackDocHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_back_doc_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.48622222,1.25458522 L0.264888889,7.37775348 C0.263111111,7.37862834 0.261333333,7.3795032 0.258666667,7.38125293 C0.0862222222,7.55097641 0,7.77581628 0,8.00065615 C0,8.22549602 0.0862222222,8.45033589 0.258666667,8.62093423 C0.261333333,8.62180909 0.264,8.62268396 0.265777778,8.62443368 L6.48355556,14.7441025 C6.82933333,15.0852992 7.39466667,15.0852992 7.74044444,14.7441025 C8.08622222,14.4046555 8.08622222,13.8473676 7.74044444,13.5070458 L3.03466667,8.87551945 L15.1111111,8.87551945 C15.6,8.87551945 16,8.48183096 16,8.00065615 C16,7.52035619 15.6,7.12666771 15.1111111,7.12666771 L3.03466667,7.12666771 L7.74311111,2.49164193 C8.08888889,2.15132011 8.08888889,1.59490705 7.74311111,1.25458522 C7.56977778,1.08486174 7.34222222,1 7.11377778,1 C6.88622222,1 6.65777778,1.08486174 6.48622222,1.25458522 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_back_doc_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clip-2",
    fill: "#5697B7",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackDocHover);
export default __webpack_public_path__ + "static/media/icon_back_doc_hover.686d9fc6fbd5c4cb1ccb897fec2c2055.svg";
export { ForwardRef as ReactComponent };